import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../lib/utils";

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const storedToken = localStorage.getItem("token");
      if (storedToken) {
        try {
          const response = await axios.get(`${API_URL}/auth/me`, {
            headers: { Authorization: `Bearer ${storedToken}` },
          });
          const userData = response.data;
          setUser(userData);
          setToken(storedToken);
          
          // Si el usuario debe cambiar la contraseña y no está en la página de cambio, redirigir
          if (userData.must_change_password && window.location.pathname !== "/change-password") {
            window.location.href = "/change-password";
          }
        } catch (error) {
          console.error("Auth init error:", error);
          localStorage.removeItem("token");
          setToken(null);
          setUser(null);
        }
      }
      setLoading(false);
    };
    initAuth();
  }, []);

  const login = async (email, password) => {
    const response = await axios.post(`${API_URL}/auth/login`, {
      email,
      password,
    });
    const { token: newToken, user: userData } = response.data;
    localStorage.setItem("token", newToken);
    setToken(newToken);
    setUser(userData);
    return userData;
  };

  const register = async (data) => {
    const response = await axios.post(`${API_URL}/auth/register`, data);
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem("token");
    setToken(null);
    setUser(null);
  };

  const isAdmin = () => user?.role === "admin";
  const isRevendedor = () => user?.role === "revendedor";
  const isSupervisor = () => user?.role === "supervisor";
  const isVigilante = () => user?.role === "vigilante";
  const canManage = () => isAdmin() || isRevendedor() || isSupervisor();
  const canManageCompanies = () => isAdmin() || isRevendedor();

  const value = {
    user,
    token,
    loading,
    login,
    register,
    logout,
    isAdmin,
    isRevendedor,
    isSupervisor,
    isVigilante,
    canManage,
    canManageCompanies,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
